import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import get from 'lodash/get'

import { ActionablesContext } from '../../../../../contexts/ActionablesContext'
import { CardContent, CardHeading, CardFooter } from '../../../../../components/layout/Card'
import { CueCard, CueCardItem } from '../../../../../components/CueCard'
import { Button } from '../../../../../components/Button'
import { Spotlight } from '../../../../../components/Spotlight'
import { R, sumCurrency } from '../../../../../utils/currency'
import { FnaContext } from '../../../context'
import { ASSESSMENT_TYPE } from '../../../reducer'

export const Show = () => {
  const {
    state: {
      fna: {
        [ASSESSMENT_TYPE.DISABILITY_COVER]: assessment
      },
      onCreateNewScenario
    },
    actions: { goToUpdateForm, goToIndex, goToDelete }
  } = useContext(FnaContext)

  const { fnaReadOnly } = useContext(ActionablesContext)
  const disabilityCoverBalance = R(get(assessment, 'balance', 0)).value

  return (
    <>
      <CardContent>
        <Box
          px='3rem'
          my='1rem'
          display='flex'
          justifyContent='space-between'
        >
          <Spotlight
            value={sumCurrency([get(assessment, 'existing_cover', 0), get(assessment, 'total_from_selected_risk_products', 0)]).format()}
            description={`Existing cover`} />
          <Spotlight
            value={R(get(assessment, 'total_immediate_expenses', 0)).format()}
            description={`Required Cover`} />
          <Spotlight
            value={R(get(assessment, 'balance', 0)).format()}
            description={disabilityCoverBalance < 0 ? 'Shortfall' : 'Surplus'}
          />
        </Box>
        <Box
          display='flex'
        >
          <Box
            m='1rem'
            width='50%'
          >
            <CueCard>
              <CardHeading>
                <h3>Things to pay for immediately</h3>
              </CardHeading>
              <CardContent>
                <CueCardItem
                  name='Lifestyle adjustment'
                  value={R(get(assessment, 'lifestyle_adjustment_expenses', 0)).format()}
                />
                <CueCardItem
                  name='Total liabilities value'
                  value={R(get(assessment, 'total_liabilities_expenses', 0)).format()}
                />
              </CardContent>
            </CueCard>
          </Box>
        </Box>
      </CardContent>
      <CardFooter className='gap-4'>
        {!fnaReadOnly &&
          <Button trackAs="Disability cover: Delete" tertiary onClick={goToDelete(ASSESSMENT_TYPE.DISABILITY_COVER)}>Delete assessment</Button>
        }
        <Button secondary onClick={goToIndex}>Go back</Button>
        {!fnaReadOnly &&
          <Button trackAs="Disability cover: Retake" onClick={goToUpdateForm(ASSESSMENT_TYPE.DISABILITY_COVER)} primary>Retake assessment</Button>
        }
        {fnaReadOnly &&
          <Button
            primary
            trackAs="Disability cover: Create new scenario"
            onClick={() => onCreateNewScenario()}
          >
            Retake in scenario planning
          </Button>
        }
      </CardFooter>
    </>
  )
}
